import type { PresentationIsEmptyProps } from '../..'
export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  const hasContent = fields?.content && fields.content.replace('<p></p>', '').trim()

  if (!hasContent) {
    return true
  }

  return false
}
